import Warehouse from '@/screens/inventory'
import Inventory from '@/screens/inventory/List'
import Historic from '@/screens/inventory/Historic'
import CaptureInventory from '@/screens/inventory/Capture'
import TrackingProducts from '@/screens/inventory/TrackingProducts'

import auth from './middleware/auth'

import store from '@/store'

const routes = [
  {
    path: '/warehouse',
    name: 'Warehouse',
    component: {
      ...Warehouse,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'Warehouse') {
          const routes = {
            manager: 'Inventory',
            chef: 'CaptureInventory',
            stockmanager: 'CaptureInventory',
            buyer: 'Inventory'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'Warehouse') {
          const routes = {
            manager: 'Inventory',
            chef: 'CaptureInventory',
            stockmanager: 'CaptureInventory',
            buyer: 'Inventory'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        path: 'inventory',
        name: 'Inventory',
        component: Inventory,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'buyer', 'stockmanager'],
          middleware: { auth }
        }
      },
      {
        path: 'capture-inventory',
        name: 'CaptureInventory',
        component: CaptureInventory,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'stockmanager', 'buyer', 'chef'],
          middleware: { auth }
        }
      },
      {
        path: 'tracking-products',
        name: 'TrackingProducts',
        component: TrackingProducts,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'stockmanager', 'buyer', 'chef'],
          middleware: { auth }
        }
      }
    ]
  },
  {
    path: '/inventoryHistoric',
    name: 'InventoryHistoric',
    component: Historic,
    meta: {
      requireAuth: true,
      permissions: ['manager', 'buyer'],
      middleware: { auth }
    }
  }
]

export default routes
